import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const FilterTimeTabsStyle = {
  wrapper: css`
    .ant-tabs-nav {
      &::before {
        display: none;
      }
      &-list {
        flex-wrap: wrap;
      }
      &-operations {
        display: none !important;
      }
    }

    .ant-tabs-tab {
      margin: unset !important;
      padding: 0 !important;

      color: ${theme.colors.orange[50]};
      &-active {
        .ant-tabs-tab-btn {
          color: ${theme.colors.orange[200]} !important;
        }
      }

      &-btn {
        padding: 4px 8px;
        border: 1px solid #ccc;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
      }
    }

    .ant-tabs-content-holder {
      display: none;
    }

    .ant-tabs-ink-bar {
      display: none;
    }
  `,
};
